
(function () {
    document.addEventListener('DOMContentLoaded', function () {

        var $body = document.querySelector('body');
        var $dropdowns = document.querySelectorAll('.main-navigation .dropdown');
        var $header = document.querySelector('header');
        var $navbar = document.querySelector('.main-navigation .navbar-collapse');
        var $navItems = document.querySelectorAll('.main-navigation .nav-item, .main-navigation .dropdown-menu .nav-link');
        var $navToggler = document.querySelector('.main-navigation .navbar-toggler');

        var currentUrl = location.pathname;

        $dropdowns.forEach(initDropdown);
        $navItems.forEach(initNavItem);

        setupDropdownInteractions();

        $body.addEventListener('click', onClickBody);

        ////

        function closeMobileNav() {
            if (!_isMobile()) {
                return;
            }

            if ($navbar.classList.contains('show')) {
                $navToggler.click();
            }
        }

        function initDropdown($dropdown) {
            var $menu = $dropdown.querySelector('.dropdown-menu');
            var $toggle = $dropdown.querySelector('.dropdown-toggle');

            var keepOpen = false;

            // Initial attach
            attachHandlers();

            // Re-attach on resize
            window.addEventListener('resize', () => {
                detachHandlers();
                attachHandlers();
            });

            ////

            // Attach handlers only if window width >= 992px
            function attachHandlers() {
                if (_isMobile()) {
                    return;
                }

                $dropdown.addEventListener('mouseenter', mouseEnterHandler);
                $dropdown.addEventListener('mouseleave', mouseLeaveHandler);

                if ($toggle) {
                    $toggle.addEventListener('click', clickHandler);
                }

                document.addEventListener('click', outsideClickHandler);
            }

            function detachHandlers() {
                $dropdown.removeEventListener('mouseenter', mouseEnterHandler);
                $dropdown.removeEventListener('mouseleave', mouseLeaveHandler);

                if ($toggle) {
                    $toggle.removeEventListener('click', clickHandler);
                }

                document.removeEventListener('click', outsideClickHandler);
            }

            // Hover logic (only if not clicked)
            function mouseEnterHandler() {
                if (!keepOpen) {
                    $dropdown.classList.add('show');
                    if ($menu) $menu.classList.add('show');
                }
            }
            function mouseLeaveHandler() {
                if (!keepOpen) {
                    $dropdown.classList.remove('show');
                    if ($menu) $menu.classList.remove('show');
                }
            }
            function clickHandler(e) {
                e.preventDefault();
                keepOpen = true;
                $dropdown.classList.add('show');
                if ($menu) $menu.classList.add('show');
            }
            function outsideClickHandler(e) {
                if (keepOpen && !$dropdown.contains(e.target)) {
                    keepOpen = false;
                    $dropdown.classList.remove('show');
                    if ($menu) $menu.classList.remove('show');
                }
            }
        }

        function initNavItem($item) {
            var $link = $item.classList.contains('nav-link') ? $item : $item.querySelector('.nav-link');

            if (!$link) {
                return;
            }

            let linkUrl = _normalizePath($link.pathname);

            console.log('xxx', linkUrl, currentUrl, linkUrl === _normalizePath(currentUrl));

            if (linkUrl === _normalizePath(currentUrl)) {
                $item.classList.add('active');

                if ($item.classList.contains('nav-link')) {
                    let $dropdownParent = $item.closest('.dropdown');

                    if ($dropdownParent) {
                        $dropdownParent.classList.add('active');

                        if (_isMobile()) {
                            let $toggleEl = $dropdownParent.querySelector('.dropdown-toggle');
                            let $menuEl = $dropdownParent.querySelector('.dropdown-menu');
                            if ($toggleEl) $toggleEl.classList.add('show');
                            if ($menuEl) $menuEl.classList.add('show');
                        }
                    }
                }
            }
        }

        function onClickBody(event) {
            if (event.target.closest('.main-navigation')) {
                return;
            }
            
            closeMobileNav();
        }

        function setupDropdownInteractions() {
            const dropdowns = document.querySelectorAll('.main-navigation .dropdown');

            dropdowns.forEach(dropdown => {
                let keepOpen = false;
                const menu = dropdown.querySelector('.dropdown-menu');
                const toggle = dropdown.querySelector('.dropdown-toggle');

                // Hover logic (only if not clicked)
                function mouseEnterHandler() {
                    if (!keepOpen) {
                        dropdown.classList.add('show');
                        if (menu) menu.classList.add('show');
                    }
                }
                function mouseLeaveHandler() {
                    if (!keepOpen) {
                        dropdown.classList.remove('show');
                        if (menu) menu.classList.remove('show');
                    }
                }
                function clickHandler(e) {
                    e.preventDefault();
                    keepOpen = true;
                    dropdown.classList.add('show');
                    if (menu) menu.classList.add('show');
                }
                function outsideClickHandler(e) {
                    if (keepOpen && !dropdown.contains(e.target)) {
                        keepOpen = false;
                        dropdown.classList.remove('show');
                        if (menu) menu.classList.remove('show');
                    }
                }

                // Attach handlers only if window width >= 992px
                function attachHandlers() {
                    if (window.innerWidth >= 992) {
                        dropdown.addEventListener('mouseenter', mouseEnterHandler);
                        dropdown.addEventListener('mouseleave', mouseLeaveHandler);
                        if (toggle) toggle.addEventListener('click', clickHandler);
                        document.addEventListener('click', outsideClickHandler);
                    }
                }
                function detachHandlers() {
                    dropdown.removeEventListener('mouseenter', mouseEnterHandler);
                    dropdown.removeEventListener('mouseleave', mouseLeaveHandler);
                    if (toggle) toggle.removeEventListener('click', clickHandler);
                    document.removeEventListener('click', outsideClickHandler);
                }

                // Initial attach
                attachHandlers();

                // Re-attach on resize
                window.addEventListener('resize', () => {
                    detachHandlers();
                    attachHandlers();
                });
            });
        }

        ////

        function _isMobile() {
            return window.innerWidth < 992;
        }

        function _normalizePath(path) {
            return path.replace(/\/$/, '');
        }

    });
})();